// Phone detection: a narrow, coarse-pointer viewport. The phone opens on the
// shopping list (cart mode) rather than the recipe gallery, and the side
// panel starts rolled up so it does not sit on top of the list.

export const PHONE_QUERY = "(max-width: 767px)";

export function isPhone(): boolean {
  if (typeof window === "undefined" || !window.matchMedia) return false;
  return window.matchMedia(PHONE_QUERY).matches;
}
